
import * as ProtoGameServer from "./proto_gameserver_base";
import NetMsgDataToBuffer from "../../../../framework/net/net_msgdata_to_buffer";

// enum {

// }

export default class NetMsgDataGameServerBase extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:"Room."为登录服，2为麻将游戏服，3为Skynet扑克服

    // 请求登录
    static Login: any[] = ["Login.LoginReq", ProtoGameServer.Login.LoginReq, "Login.LoginRsp", ProtoGameServer.Login.LoginRsp, 3]
    // 心跳包
    static Ping: any[] = ["Login.PingReq", ProtoGameServer.Login.PingReq, "Login.PingRsp", ProtoGameServer.Login.PingRsp, 3]
}
